import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from 'vue';
import type { TLlmFeedbackRating } from '@/_core/entities/llm-feedback/models/types';
import ThumbsUpIcon from '@/assets/images/svg/thumbs-up.svg?component';
import ThumbsDownIcon from '@/assets/images/svg/thumbs-down.svg?component';


export default /*#__PURE__*/_defineComponent({
  __name: 'LlmFeedbackRating',
  props: {
    rating: null,
    isPending: { type: Boolean },
    activeClass: { default: 'tw:text-main-blue' },
    inactiveClass: { default: 'tw:text-secondary hover:tw:text-main-blue' }
  },
  emits: ["rate"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'rate', rating: TLlmFeedbackRating): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { rating: TLlmFeedbackRating | null, isPending?: boolean, activeClass: string, inactiveClass: string };





function handleClick(value: TLlmFeedbackRating) {
  if (props.isPending) return;
  if (props.rating === value) return;
  emit('rate', value);
}

return { __sfc: true,props, emit, handleClick, ThumbsUpIcon, ThumbsDownIcon }
}

})